export const retailPaymentTypes = {
	immediate: 'immediate',
	futureDated: 'futureDated',
	repeating: 'repeating',
};
